import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, RequireAuth } from "@/auth/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { InstallPrompt } from "@/components/InstallPrompt";
import { UpdateBanner } from "@/components/UpdateBanner";
import { PullToRefresh } from "@/components/PullToRefresh";
import { PortalInstallGate } from "@/components/PortalInstallGate";
import Home from "@/pages/Home";
import Elite from "@/pages/Elite";
import VideoSessions from "@/pages/VideoSessions";
import PrivateTraining from "@/pages/PrivateTraining";
import Login from "@/pages/Login";
import Portal from "@/pages/Portal";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import { CoachLayout } from "@/pages/coach/CoachLayout";
import Overview from "@/pages/admin/Overview";
import Players from "@/pages/admin/Players";
import Attendance from "@/pages/admin/Attendance";
import Trials from "@/pages/admin/Trials";
import Reports from "@/pages/admin/Reports";
import Coaches from "@/pages/admin/Coaches";
import Payments from "@/pages/admin/Payments";
import Dues from "@/pages/admin/Dues";
import Reminders from "@/pages/admin/Reminders";
import Tournaments from "@/pages/admin/Tournaments";
import Feedback from "@/pages/admin/Feedback";
import Workouts from "@/pages/admin/Workouts";
import Documents from "@/pages/admin/Documents";
import Policies from "@/pages/admin/Policies";
import Centres from "@/pages/admin/Centres";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    {children}
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <PullToRefresh />
          <Routes>
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/elite" element={<PublicLayout><Elite /></PublicLayout>} />
            <Route path="/video-sessions" element={<PublicLayout><VideoSessions /></PublicLayout>} />
            <Route path="/private-training" element={<PublicLayout><PrivateTraining /></PublicLayout>} />
            <Route path="/login" element={<Login />} />
            <Route path="/portal" element={<RequireAuth role="parent"><Portal /></RequireAuth>} />
            <Route path="/coach" element={<RequireAuth role="coach"><CoachLayout /></RequireAuth>}>
              <Route index element={<Attendance />} />
              <Route path="reports" element={<Reports />} />
            </Route>
            <Route path="/admin" element={<RequireAuth role="admin"><AdminLayout /></RequireAuth>}>
              <Route index element={<Overview />} />
              <Route path="players" element={<Players />} />
              <Route path="attendance" element={<Attendance />} />
              <Route path="trials" element={<Trials />} />
              <Route path="reports" element={<Reports />} />
              <Route path="coaches" element={<Coaches />} />
              <Route path="payments" element={<Payments />} />
              <Route path="dues" element={<Dues />} />
              <Route path="reminders" element={<Reminders />} />
              <Route path="tournaments" element={<Tournaments />} />
              <Route path="feedback" element={<Feedback />} />
              <Route path="resource-bank" element={<Workouts />} />
              <Route path="workouts" element={<Navigate to="/admin/resource-bank" replace />} />
              <Route path="documents" element={<Documents />} />
              <Route path="policies" element={<Policies />} />
              <Route path="centres" element={<Centres />} />
            </Route>
          </Routes>
          <Toaster theme="dark" position="bottom-right" />
          <UpdateBanner />
          <InstallPrompt />
          <PortalInstallGate />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
